// iframe 고정 높이 설정 스크립트
function resizeIframe(iframe) {
    // 헤더 iframe은 무조건 고정 높이 사용 (동적 변경 금지)
    if (iframe.classList.contains('iframe-header')) {
        iframe.style.height = '80px'; // 실제 헤더 높이로 축소
        return;
    }
    
    iframe.onload = function() {
        try {
            // 푸터 iframe만 내용에 맞춰 높이 조절
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            const height = iframeDoc.documentElement.scrollHeight;
            iframe.style.height = height + 'px';
            
        } catch (error) {
            // CORS 오류 등으로 접근할 수 없는 경우 기본 높이 설정
            if (iframe.classList.contains('iframe-footer')) {
                iframe.style.height = '300px';
            }
        }
    };
}

// 모든 iframe-include 클래스를 가진 iframe에 자동 높이 조절 적용
document.addEventListener('DOMContentLoaded', function() {
    const iframes = document.querySelectorAll('.iframe-include');
    iframes.forEach(iframe => {
        resizeIframe(iframe);
        
        // iframe 내용 변경 시에도 높이 재조절
        iframe.addEventListener('load', function() {
            resizeIframe(iframe);
        });
    });
});

// 윈도우 리사이즈 시 iframe 높이 재조절
window.addEventListener('resize', function() {
    const iframes = document.querySelectorAll('.iframe-include');
    iframes.forEach(iframe => {
        resizeIframe(iframe);
    });
});